import { render } from "./IconGroup.vue?vue&type=template&id=45896223"
import script from "./IconGroup.vue?vue&type=script&lang=js"
export * from "./IconGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__